module.exports = __webpack_public_path__ + "static/img/amp-crunch.d209dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp-crunch.png
// module id = RQdG
// module chunks = 12